/**
 * Stack Component Variants
 *
 * CVA variants for the Stack component.
 * Separated to allow React Fast Refresh to work properly.
 */

import { cva } from 'class-variance-authority';

// =============================================================================
// VARIANTS
// =============================================================================

export const stackVariants = cva('flex flex-col', {
  variants: {
    /**
     * Gap between items using Tailwind spacing scale
     * Named: xs=8px, sm=12px, md=16px, lg=24px, xl=32px, 2xl=48px
     * Numeric: 0-16 map to gap-0 through gap-16
     */
    gap: {
      // Numeric scale (Tailwind spacing)
      0: 'gap-0',
      1: 'gap-1',
      2: 'gap-2',
      3: 'gap-3',
      4: 'gap-4',
      5: 'gap-5',
      6: 'gap-6',
      8: 'gap-8',
      10: 'gap-10',
      12: 'gap-12',
      16: 'gap-16',
      // Named scale (semantic)
      xs: 'gap-2',
      sm: 'gap-3',
      md: 'gap-4',
      lg: 'gap-6',
      xl: 'gap-8',
      '2xl': 'gap-12',
    },
    /**
     * Horizontal alignment of items (cross-axis)
     */
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
    },
    /**
     * Vertical distribution of items (main-axis)
     */
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly',
    },
    /**
     * Internal padding using Tailwind spacing scale
     */
    padding: {
      none: 'p-0',
      xs: 'p-2',
      sm: 'p-3',
      md: 'p-4',
      lg: 'p-6',
      xl: 'p-8',
    },
    /**
     * Whether the stack should fill its container width
     */
    fullWidth: {
      true: 'w-full',
      false: '',
    },
    /**
     * Whether the stack should fill available height
     */
    fullHeight: {
      true: 'h-full',
      false: '',
    },
  },
  defaultVariants: {
    gap: 'md',
    align: 'stretch',
    justify: 'start',
    fullWidth: false,
    fullHeight: false,
  },
});
